export default "__VITE_ASSET__6975d9e6__"